module.exports = __webpack_public_path__ + "img/Mask Group 52.15ec8fb1.png";